import {
  Wrapper
} from './styles'

// components
import DiscordIcon from 'components/StaticIcons/Discord'
import InstagramIcon from 'components/StaticIcons/Instagram'
// import LinkedinIcon from 'components/StaticIcons/Linkedin'
import TelegramIcon from 'components/StaticIcons/Telegram'
import TwitterIcon from 'components/StaticIcons/Twitter'

export default function Socials() {
  return (
    <Wrapper>
      <a href="https://discord.gg/Sm4JMZeN6S" target="_blank"> <DiscordIcon /> </a>
      <a href="https://www.instagram.com/theprime_gg/" target="_blank"> <InstagramIcon /> </a>
      {/* <a href="#" target="_blank"> <LinkedinIcon /> </a> */}
      <a href="https://t.me/theprimegg" target="_blank"> <TelegramIcon /> </a>
      <a href="https://twitter.com/theprime_gg" target="_blank"> <TwitterIcon /> </a>
    </Wrapper>
  );
}